<mat-icon class="font-size-16" *ngIf="isMatrixRowDelete" #tooltip="matTooltip" matTooltip="Delete"
    [matTooltipPosition]="tooltip_position">
    <a href="javascript:void(0)" (click)="open(mymodal_delete1)">delete</a>
</mat-icon>

<ng-template #mymodal_delete1 let-modal>
    <div class="modal-header">
        <h4>Confirm Calculation Delete</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i
                class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable">
        <div class="row">
            <div class="col-md-12" style="padding: 15px">
                <p>Are you sure you want to permanently remove this entires?</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="btnDeleteMatrixRow()">Ok</button>
        <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
    </div>
</ng-template>